import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'
import usePopup, { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import {
  generateResolutionLinkPopupWithPayload,
  resolutionLinkGeneratedPopupWithPayload
} from '../constants'
import {
  GenerateResolutionLinkPopupPayload,
  ResolutionLinkGeneratedPopupPayload
} from '../types'

type ContextProps = {
  generateResolutionLinkPopup: PopupReturnTypeWithPayload<GenerateResolutionLinkPopupPayload>
  resolutionLinkGeneratedPopup: PopupReturnTypeWithPayload<ResolutionLinkGeneratedPopupPayload>
}

const basePopup = (title: string) => ({
  title
})

const MyOrganizationCommunityPopupContext = createContext<ContextProps>({
  generateResolutionLinkPopup: generateResolutionLinkPopupWithPayload,
  resolutionLinkGeneratedPopup: resolutionLinkGeneratedPopupWithPayload
})

const MyOrganizationCommunityPopupProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const generateResolutionLinkPopupProps =
    usePopup<GenerateResolutionLinkPopupPayload>(
      basePopup('Generate resolution link')
    )
  const resolutionLinkGeneratedPopupProps = usePopup<{}>(
    basePopup('Link generated')
  )
  const context = useMemo(
    () => ({
      generateResolutionLinkPopup: generateResolutionLinkPopupProps,
      resolutionLinkGeneratedPopup: resolutionLinkGeneratedPopupProps
    }),
    [generateResolutionLinkPopupProps, resolutionLinkGeneratedPopupProps]
  )

  return (
    <MyOrganizationCommunityPopupContext.Provider value={context}>
      {children}
    </MyOrganizationCommunityPopupContext.Provider>
  )
}

export const useMyOrganizationCommunityPopup = () =>
  useContext(MyOrganizationCommunityPopupContext)

export default MyOrganizationCommunityPopupProvider
